import { useEffect, useState } from 'react'
import { fileFile } from '../../../modules/uploadfiles/hooks'
import { DOWNLOAD_ACCEPT_TEMP } from '../../../api/orderManage'
import { history } from '../../../redux/store'
import { orderStateEnum } from '../../../global/enums'
export interface Props {
  infoObj: {
    cancelReturnPrice: number
    code: string
    detailedProductDTOList: any[]
    directShipment: boolean
    finalPrice: number
    groupName: string
    id: string
    orderCreateTime: string
    orderState: string
    orderStateToName: string
    price: number
    purchaseGroupName: string
    receiveAddress: string
    receiveMan: string
    receiveMobile: string
    warehousingProgress: string
    supplierOrderId: string
    purchaseMan: string
    address: string
  }
}

export const invoicingStateDict: any = {
  '1': '已开票',
  '2': '未开票',
}
export default function useHook(props: Props) {
  const { infoObj } = props

  const [uploadfilesList, setUploadfilesList] = useState<fileFile[]>([])
  const getStateColor = () => {
    const stateDesp =
      orderStateEnum.getLabelByValue(infoObj.orderState as any) ?? ''
    if (['完成', '已完成', '待履约'].includes(stateDesp)) {
      return 'black'
    } else if (['已取消', '已退货'].includes(infoObj.orderState)) {
      return 'red'
    } else {
      return 'orange'
    }
  }

  const handleUploadfilesChange = (e: fileFile[]) => {
    setUploadfilesList(e)
  }
  const handleOrderTempDownload = async () => {
    await DOWNLOAD_ACCEPT_TEMP({ id: infoObj.id })
  }
  useEffect(() => {
    setUploadfilesList(infoObj?.detailedProductDTOList || [])
    // eslint-disable-next-line
  }, [infoObj?.detailedProductDTOList])
  const jumpDetail = () => {
    history.replace({
      pathname: '/srm/ordersupplierdetail',
      state: {
        id: infoObj.supplierOrderId,
      },
    })
  }
  return {
    infoObj,
    jumpDetail,
    uploadfilesList,
    handleUploadfilesChange,
    getStateColor,
    handleOrderTempDownload,
  }
}
import { useEffect, useState } from 'react'
import { fileFile } from '../../../modules/uploadfiles/hooks'
import { DOWNLOAD_ACCEPT_TEMP } from '../../../api/orderManage'
import { history } from '../../../redux/store'
import { orderStateEnum } from '../../../global/enums'
export interface Props {
  infoObj: {
    cancelReturnPrice: number
    code: string
    detailedProductDTOList: any[]
    directShipment: boolean
    finalPrice: number
    groupName: string
    id: string
    orderCreateTime: string
    orderState: string
    orderStateToName: string
    price: number
    purchaseGroupName: string
    receiveAddress: string
    receiveMan: string
    receiveMobile: string
    warehousingProgress: string
    supplierOrderId: string
    purchaseMan: string
    address: string
  }
}

export const invoicingStateDict: any = {
  '1': '已开票',
  '2': '未开票',
}
export default function useHook(props: Props) {
  const { infoObj } = props

  const [uploadfilesList, setUploadfilesList] = useState<fileFile[]>([])
  const getStateColor = () => {
    const stateDesp =
      orderStateEnum.getLabelByValue(infoObj.orderState as any) ?? ''
    if (['完成', '已完成', '待履约'].includes(stateDesp)) {
      return 'black'
    } else if (['已取消', '已退货'].includes(infoObj.orderState)) {
      return 'red'
    } else {
      return 'orange'
    }
  }

  const handleUploadfilesChange = (e: fileFile[]) => {
    setUploadfilesList(e)
  }
  const handleOrderTempDownload = async () => {
    await DOWNLOAD_ACCEPT_TEMP({ id: infoObj.id })
  }
  useEffect(() => {
    setUploadfilesList(infoObj?.detailedProductDTOList || [])
    // eslint-disable-next-line
  }, [infoObj?.detailedProductDTOList])
  const jumpDetail = () => {
    history.replace({
      pathname: '/srm/ordersupplierdetail',
      state: {
        id: infoObj.supplierOrderId,
      },
    })
  }
  return {
    infoObj,
    jumpDetail,
    uploadfilesList,
    handleUploadfilesChange,
    getStateColor,
    handleOrderTempDownload,
  }
}
